import firebaseService from './firebase.service';
import webPermissions, { CLIENT_TYPE } from './webPermissions.service';

class FirebasePlatformCommunicationService {
  private static instance: FirebasePlatformCommunicationService;

  public static getInstance(): FirebasePlatformCommunicationService {
    if (!FirebasePlatformCommunicationService.instance) {
      FirebasePlatformCommunicationService.instance = new FirebasePlatformCommunicationService();
    }
    return FirebasePlatformCommunicationService.instance;
  }

  // eslint-disable-next-line class-methods-use-this
  public async initializeFirebaseApp(webConfig: string): Promise<any> {
    const clientType = webPermissions.getClientType();
    console.debug(`[Firebase Platform] Initializing Firebase app for client type: ${clientType}`);

    if (clientType === CLIENT_TYPE.WEB) {
      return firebaseService.initializeFirebaseApp(webConfig);
    }

    if (clientType === CLIENT_TYPE.NATIVE_IOS || clientType === CLIENT_TYPE.NATIVE_ANDROID) {
      // No-op for native mobile platforms.
      return Promise.resolve(null);
    }

    throw new Error(`Unsupported client type: ${clientType}`);
  }

  // eslint-disable-next-line class-methods-use-this
  public async registerFirebaseServiceWorker(): Promise<ServiceWorkerRegistration> {
    const clientType = webPermissions.getClientType();
    console.debug(
      `[Firebase Platform] Registering Firebase service worker for client type: ${clientType}`,
    );

    if (clientType === CLIENT_TYPE.WEB) {
      return firebaseService.registerFirebaseServiceWorker();
    }

    if (clientType === CLIENT_TYPE.NATIVE_IOS || clientType === CLIENT_TYPE.NATIVE_ANDROID) {
      // No-op for native mobile platforms.
      return Promise.resolve(null);
    }

    throw new Error(`Unsupported client type: ${clientType}`);
  }

  // eslint-disable-next-line class-methods-use-this
  public async retrieveFirebaseMessagingToken(
    webConfig: string,
    vapidKey: string,
  ): Promise<string> {
    const clientType = webPermissions.getClientType();
    console.debug(
      `[Firebase Platform] Retrieving Firebase messaging token for client type: ${clientType}`,
    );

    if (clientType === CLIENT_TYPE.WEB) {
      return firebaseService.retrieveFirebaseMessagingToken(webConfig, vapidKey);
    }

    if (clientType === CLIENT_TYPE.NATIVE_IOS || clientType === CLIENT_TYPE.NATIVE_ANDROID) {
      // Call native app bridge. To be completed in WC-4348.
    }

    throw new Error(`Unsupported client type: ${clientType}`);
  }

  // eslint-disable-next-line class-methods-use-this
  public async deleteFirebaseMessagingToken(webConfig: string, vapidKey: string): Promise<void> {
    const clientType = webPermissions.getClientType();
    console.debug(
      `[Firebase Platform] Deleting Firebase messaging token for client type: ${clientType}`,
    );

    if (clientType === CLIENT_TYPE.WEB) {
      return firebaseService.deleteFirebaseMessagingToken(webConfig, vapidKey);
    }

    if (clientType === CLIENT_TYPE.NATIVE_IOS || clientType === CLIENT_TYPE.NATIVE_ANDROID) {
      // Call native app bridge. To be completed in WC-4348.
    }

    throw new Error(`Unsupported client type: ${clientType}`);
  }
}

export default FirebasePlatformCommunicationService.getInstance();
